import styles from './Separator.module.scss'

interface SeparatorProps {
  text: string
}

const Separator: React.FC<SeparatorProps> = ({ text }) => {
  return (
    <div className={styles.separator}>
      <div className={styles.line} />
      <span className={styles.text}>{text}</span>
      <div className={styles.line} />
    </div>
  )
}

export default Separator
